<div class="services" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <div *ngFor="let comp of productsCategories">
    <ng-container [ngSwitch]="comp.type">
      <div *ngSwitchCase="'tabs'">
        <app-tabs
          [data]="comp.details"
          (selectedTabChange)="onTabChange($event)"
        />
      </div>
      <!-- <div *ngSwitchCase="'multi-text-with-image'">
        <div *ngIf="!selectedTab || selectedTab === comp.fileName">
          <app-multi-text-with-image
            [data]="comp.details"
            [language]="language"
            [fileName]="'service-page/' + comp.fileName"
          ></app-multi-text-with-image>
        </div>
      </div> -->
      <div *ngSwitchCase="'product-card'">
        <div *ngIf="!selectedTab || selectedTab === comp.fileName">
          <app-product-card
            [data]="comp.details"
            [language]="language"
            [fileName]="'product-page/' + comp.fileName"
          />
        </div>
      </div>
      <div class="" *ngSwitchCase="'grid-without-frame'">
        <app-grid-cards-without-frame
          [data]="comp"
          [language]="language"
          [fileName]="'product-page/' + comp.fileName"
        ></app-grid-cards-without-frame>
      </div>
      <div class="" *ngSwitchCase="'projects'">
        <app-our-projects
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-our-projects>
      </div>
      <div class="" *ngSwitchCase="'image-with-text'">
        <app-image-with-text
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-image-with-text>
      </div>
      <div class="" *ngSwitchCase="'multi-images-with-text'">
        <app-multi-images-with-text
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-multi-images-with-text>
      </div>
      <div class="" *ngSwitchCase="'multi-images-with-text'">
        <app-multi-images-with-text
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-multi-images-with-text>
      </div>
      <div *ngSwitchCase="'multi-text-with-image'">
        <app-multi-text-with-image
          [data]="comp.details"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-multi-text-with-image>
      </div>
    </ng-container>
  </div>
</div>
